import { gql, useMutation } from '@apollo/client';
import { useGraphql } from 'utils/hooks/useGraphql';
import { useDispatch } from 'react-redux';
import { addNegativeToast, addPositiveToast } from 'modules/toastContainer';

const getAnonUserCriteriaSettingsQuery = gql`
    query getAnonUserCriteriaSettings {
      getAnonUserCriteriaSettings {
        setting {
          id
          projectId
          createdAt
          isSdkSetupWorking
          enableUserRetention
          ageInDays
          excludedListIds
          retentionPolicyUpdatedAt
          retentionPolicyUpdatedBy
          retentionJobEnqueuedAt
          isRetentionJobEnqueueSuccess
        }
        failure {
          __typename
        }
      }
    }
`;

export const useGetAnonUserCriteriaSettings = () => {
  const anonUserCriteriaSettings = useGraphql(getAnonUserCriteriaSettingsQuery);
  return anonUserCriteriaSettings;
};

export const mutateUserRetentionControls = gql`
    mutation UpdateUserRetentionControls($enableUserRetention: Boolean!, $ageInDays: Int!, $excludedListIds: [Long!]) {
        updateUserRetentionControls(
            enableUserRetention: $enableUserRetention,
            ageInDays: $ageInDays,
            excludedListIds: $excludedListIds
        ) {
            setting {
                id
                projectId
                createdAt
                isSdkSetupWorking
                enableUserRetention
                ageInDays
                excludedListIds
                retentionPolicyUpdatedAt
                retentionPolicyUpdatedBy
                retentionJobEnqueuedAt
                isRetentionJobEnqueueSuccess
            }
            failure {
                __typename
            }
        }
    }`;

export const useUpdateUserRetentionControls = (onSuccess: () => void) => {
  const dispatch = useDispatch();
  const [updateUserRetentionControls] = useMutation(mutateUserRetentionControls, {
    onCompleted: (response) => {
      if (response?.updateUserRetentionControls?.failure) {
        dispatch(
          addNegativeToast(
            'Error updating retention period for unknown users. Please try again later.',
          ),
        );
      } else if (response?.updateUserRetentionControls?.setting) {
        // close the takeover
        onSuccess();
        dispatch(addPositiveToast('Success! Retention period updated for unknown users.'));
      }
    },
    onError: (_error) => {
      dispatch(
        addNegativeToast(
          'Error updating retention period for unknown users. Please try again later.',
        ),
      );
    },
  });
  return updateUserRetentionControls;
};
